export default __webpack_public_path__ + "static/media/VectorTile_Variant01.3996a855.jpg";